import { render } from "./tags-multiselect.vue?vue&type=template&id=29b0e1ad&lang=pug"
import script from "./tags-multiselect.vue?vue&type=script&lang=js"
export * from "./tags-multiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__